import React from "react";
import { useUscSelector } from "../../../../redux/store";
import type { OpeningHoursType } from "../../../../../../common-deprecated/utils/dealerConstants";
import Text from "../../../../../shared-components/lexus/styles/atoms/Text";
import List from "../../styles/atoms/List";
import { parseDealerOpeningHours } from "../../../../utils/pdpUtils";

type PropsType = {
    openingHours: OpeningHoursType[];
};

const OpeningHours = (props: PropsType): JSX.Element => {
    const { openingHours } = props;
    const culture = useUscSelector((state) => state.commonSettings.culture);
    const parsedHours = parseDealerOpeningHours(openingHours, culture);

    return (
        <List variant="specs">
            {parsedHours.map((openingsHour) => (
                <li key={openingsHour.days}>
                    <Text variant="paragraph-body-book" color="brushed-steel">
                        {openingsHour.days}
                    </Text>
                    <Text variant="paragraph-body-book" color="brushed-steel">
                        {openingsHour.hours.map((times) => (
                            <div key={times}>{times}</div>
                        ))}
                    </Text>
                </li>
            ))}
        </List>
    );
};

export default OpeningHours;
